"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SessionParticipantsSearchFieldEnum = exports.SessionParticipantsSortByEnum = void 0;
var SessionParticipantsSortByEnum;
(function (SessionParticipantsSortByEnum) {
    SessionParticipantsSortByEnum["FIRST_NAME"] = "firstName";
    SessionParticipantsSortByEnum["LAST_NAME"] = "lastName";
    SessionParticipantsSortByEnum["AGE"] = "age";
    SessionParticipantsSortByEnum["GENDER"] = "gender";
    SessionParticipantsSortByEnum["REGISTRATION_DATE"] = "registrationDate";
    SessionParticipantsSortByEnum["WAIVER_SIGNED_DATE"] = "waiverSignedDate";
    SessionParticipantsSortByEnum["WAIVER_SIGNED"] = "waiverSigned";
    SessionParticipantsSortByEnum["FOLDER_NAME"] = "folderName";
})(SessionParticipantsSortByEnum = exports.SessionParticipantsSortByEnum || (exports.SessionParticipantsSortByEnum = {}));
var SessionParticipantsSearchFieldEnum;
(function (SessionParticipantsSearchFieldEnum) {
    SessionParticipantsSearchFieldEnum["NAME_OR_EMAIL"] = "nameOrEmail";
    SessionParticipantsSearchFieldEnum["PRODUCT_NAME"] = "productName";
})(SessionParticipantsSearchFieldEnum = exports.SessionParticipantsSearchFieldEnum || (exports.SessionParticipantsSearchFieldEnum = {}));
//# sourceMappingURL=enums.js.map